module.exports = __webpack_public_path__ + "img/sucess.24a38b38.png";